$(function() {
	function progressBarHandler(carousel, progressBar) {
		var count = parseInt(carousel.data('elementCount') || '1') - 1;
		var current = parseInt(carousel.data('elementCurrent') || '0');
		if (count > 0) progressBar.css('width', (current / count) * 100 + '%');
		else if (count == 0) {
			progressBar.css('width', '100%');
		} else {
			progressBar.css('width', '0%');
		}
	}

	function initSportsCarousel() {
		var sportsCarousel = $('#pl_carousel_sports_tablet');
		const sportsProgressBar = $('#pl_sports-pb-m');
		if (sportsCarousel) {
			sportsCarousel.data('elementCurrent', 0);
			sportsCarousel.data(
				'elementCount',
				$('#pl_carousel_sports_tablet .carousel-inner .carousel-item')
					.length
			);
			sportsCarousel.on('slide.bs.carousel', function(data) {
				sportsCarousel.data('elementCurrent', data.to);
				progressBarHandler(sportsCarousel, sportsProgressBar);
			});
		}
	}

	initSportsCarousel();
});
